export default "__VITE_ASSET__04d92e44__"